var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-option-tree"},[_c('t-tree',{ref:"tree",attrs:{"data":_vm.optionTreeData,"props":_vm.optionTreeProps,"node-key":_vm.nodeKey,"default-expanded-keys":_vm.defaultExpandedKeys,"filter-node-method":_vm.filterNode},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3f53e8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/select/src/option-tree.vue
// module id = xtHL
// module chunks = 2